import { render, staticRenderFns } from "./SelectorIdioma.vue?vue&type=template&id=efe59c98"
import script from "./SelectorIdioma.vue?vue&type=script&lang=js"
export * from "./SelectorIdioma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports